import { useEffect } from 'react'
import { v4 as randomUUID } from 'uuid'

import { ZELLER_SESSION_CLIENT_ID } from 'const/envs'
import { SESSION_STORAGE_KEYS } from 'services/sessionStorage/keys'
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from 'services/sessionStorage/utils'

export const useSetZellerSessionId = () => {
  useEffect(() => {
    const hasZellerSessionClientId = Boolean(ZELLER_SESSION_CLIENT_ID)
    const zellerSessionId = getSessionStorageItem(
      SESSION_STORAGE_KEYS.ZELLER_SESSION_ID
    )
    if (hasZellerSessionClientId && !zellerSessionId) {
      const zellerSessionId = randomUUID()

      setSessionStorageItem(
        SESSION_STORAGE_KEYS.ZELLER_SESSION_ID,
        zellerSessionId
      )
    }
  }, [])
}
